import React, { useEffect, useState } from "react";

/**
 * Plays a video whose URL requires Bearer auth (same pattern as AuthImage).
 * Fetches as blob and hands react a local object URL.
 */
export default function AuthVideo({ src, className = "" }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let currentUrl = null;
    const token = localStorage.getItem("wrm_token");
    const url = src?.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.blob() : Promise.reject(r.status)))
      .then((b) => {
        if (cancelled) return;
        currentUrl = URL.createObjectURL(b);
        setBlobUrl(currentUrl);
      })
      .catch(() => !cancelled && setErr(true));
    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [src]);

  if (err) return <div className={`text-xs text-red-500 ${className}`}>Impossible de charger la vidéo</div>;
  if (!blobUrl) return <div className={`bg-slate-100 animate-pulse aspect-video rounded-lg ${className}`} />;
  return (
    <video data-testid="help-video-player" src={blobUrl} controls className={`w-full rounded-lg bg-black ${className}`} />
  );
}
